import angular from 'angular';

import roundingFilter from './rounding.filter';
import dottedNumberFilter from './dotted-number.filter';
import roomsFilter from './rooms.filter';
import phoneFilter from './phone.filter';
import mobileMillionFilter from './mobile-million.filter';
import addressFilter from './address.filter';
import picOrderFilter from './property-images.filter';

const MODULE_NAME = 'filters';

export default angular.module(MODULE_NAME, [])
	.filter('roundingFilter', roundingFilter)
	.filter('dottedNumberFilter', dottedNumberFilter)
	.filter('roomsFilter', ['$filter', roomsFilter])
	.filter('phoneFilter', phoneFilter)
	.filter('mobileMillionFilter', mobileMillionFilter)
	.filter('address', addressFilter)
	.filter('picOrderFilter', picOrderFilter).name;


